/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  CircularProgress,
  Container,
  Typography,
  useTheme,
  Toolbar
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import RiderImage from "../../../assets/images/rider.png";
import UserContext from "../../../context/User";
import { useRestaurants } from "../../../hooks"; // Changed to useRestaurants
import CartItem from "./CartItem";
import PricingView from "./PricingView";
import useStyles from "./styles";
import { useTranslation } from "react-i18next";

function CartView(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();
  const [loadingData, setLoadingData] = useState(true);
  const {
    clearCart,
    cart,
    cartCount,
    addQuantity,
    removeQuantity,
    updateCart,
  } = useContext(UserContext);
  const { data } = useRestaurants(); // Fetch all restaurants
  const restaurants = data?.restaurants ?? []; // Ensure restaurants is always an array

  useEffect(() => {
    if (restaurants.length > 0) didFocus();
  }, [restaurants, cartCount]);

  const didFocus = async () => {
    // Flatten foods, addons, and options for each restaurant and map them based on restaurantId in cart
    const allFoods = restaurants.reduce((acc, restaurant) => {
      const foods = restaurant.categories.map((c) => c.foods.flat()).flat();
      acc[restaurant._id] = {
        foods,
        addons: restaurant.addons,
        options: restaurant.options,
      };
      return acc;
    }, {});

    try {
      if (cart && cartCount) {
        const transformCart = cart.map((cartItem) => {
          const { restaurantId } = cartItem;
          const { foods, addons, options } = allFoods[restaurantId] || {};

          if (!foods) return null;

          const foodItem = foods.find((food) => food._id === cartItem._id);
          if (!foodItem) return null;

          const variationItem = foodItem.variations.find(
            (variation) => variation._id === cartItem.variation._id
          );
          if (!variationItem) return null;

          const foodItemTitle = `${foodItem.title}${
            variationItem.title ? `(${variationItem.title})` : ""
          }`;
          let foodItemPrice = variationItem.price;
          let optionTitles = [];

          if (cartItem.addons) {
            cartItem.addons.forEach((addon) => {
              const cartAddon = addons.find((add) => add._id === addon._id);
              if (!cartAddon) return null;
              addon.options.forEach((option) => {
                const cartOption = options.find(
                  (opt) => opt._id === option._id
                );
                if (!cartOption) return null;
                foodItemPrice += cartOption.price;
                optionTitles.push(cartOption.title);
              });
            });
          }

          return {
            ...cartItem,
            title: foodItemTitle,
            foodTitle: foodItem.title,
            variationTitle: variationItem.title,
            optionTitles,
            price: foodItemPrice.toFixed(2),
          };
        });

        const updatedItems = transformCart.filter((item) => item);
        if (updatedItems.length === 0) await clearCart();
        await updateCart(updatedItems);

        setLoadingData((prev) => (prev ? false : prev));

        if (transformCart.length !== updatedItems.length) {
          props.showMessage({
            type: t("warning"),
            message: t("warningText"),
          });
        }
      }
    } catch (e) {
      props.showMessage({
        type: "error",
        message: e.message,
      });
    } finally {
      setLoadingData((prev) => (prev ? false : prev));
    }
  };

  if (loadingData) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
    <Toolbar /> {/* Spacer that matches the header's height */}
      <Box
        style={{
          background:
            "linear-gradient(260.99deg, theme.palette.primary.main 2.79%, theme.palette.success.light 96.54%)",
          borderRadius: "20px",
          padding: "30px 20px",
        }}
        display="flex"
        alignItems={"center"}
      >
        <Box display="flex" alignItems="center" justifyContent="center">
          <img src={RiderImage} alt="rider" />
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          style={{
            marginLeft: "5px",
          }}
        >
          <Typography
            style={{
              ...theme.typography.body1,
              color: theme.palette.common.black,
              fontSize: "1.275rem",
              fontWeight: 600,
            }}
          >
            {t("deliveryTime")}
          </Typography>
          {/* <Typography
            style={{
              ...theme.typography.body1,
              color: theme.palette.text.disabled,
              fontSize: "0.875rem",
            }}
          >
            {`${restaurants.find(r => r._id === cart[0]?.restaurantId)?.deliveryTime ?? "..."} min`}
          </Typography> */}
          <Typography
            variant="h6"
            color="textSecondary"
            style={{ fontSize: "0.78rem" }}
            className={classes.textBold}
          >
            {`Your order will be dropped off at one of our delivery locations at the time specified.`}
          </Typography>
        </Box>
      </Box>
      <Container
        style={{
          maxHeight: "30vh",
          overflowY: "scroll",
          paddingBottom: theme.spacing(2),
          background: theme.palette.common.white,
          marginBottom: 10,
        }}
      >
        {cart?.map((foodItem) => {
  // Log date and time to check their values


  return (
    <CartItem
      key={`ITEM_${foodItem.key}`}
      quantity={foodItem.quantity}
      dealName={foodItem.title}
      foodTitle={foodItem.foodTitle}
      variationTitle={foodItem.variationTitle}
      optionTitles={foodItem.optionTitles}
      date={foodItem.date}
      time={foodItem.time}
      dealPrice={(parseFloat(foodItem.price) * foodItem.quantity).toFixed(2)}
      addQuantity={() => {
        addQuantity(foodItem.key);
      }}
      removeQuantity={() => {
        removeQuantity(foodItem.key);
      }}
    />
  );
})}

      </Container>
      <PricingView
        restaurantData={restaurants.find(r => r._id === cart[0]?.restaurantId)}
        deliveryCharges={
          restaurants.find(r => r._id === cart[0]?.restaurantId)?.deliveryCharges
        }
      />
    </>
  );
}

export default React.memo(CartView);
